import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { type Media } from "@/types";

import { profile } from "@/modules/profile/user/services";

export type UploadType = "image" | "file" | "video" | "audio";

export const useUploadFile = (
  type: UploadType,
  onProgress?: (progress: number | undefined) => void,
  fields?: Record<string, string>,
) => {
  return useMutation({
    mutationFn: (file: File) =>
      api
        .post<Media>(
          `upload/${type}`,
          {
            file,
            ...fields,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (event) => onProgress?.(event.progress),
          },
        )
        .then((res) => res.data),
    onSuccess: () => {},
  });
};

interface UpdateProfilePictureRequest {
  image: string;
}

export const useUpdateProfilePicture = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateProfilePictureRequest) =>
      api.put(`/me/profile-picture`, data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries(profile.one("me"));
    },
  });
};

export const useDeleteProfilePicture = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.delete(`/me/profile-picture`),
    onSuccess: () => {
      queryClient.invalidateQueries(profile.one("me"));
    },
  });
};
